/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SWMtoLegalLink.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SlidingComponentLinkTemplate from "./SlidingComponentLinkTemplate";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import CustomSearchbarWithApiV2 from "../../../components/customComponentsV2/common/searchBar/CustomSearchbarWithApiV2";
import { HandleApiActions, labCar } from "../../../redux/actions";
import { componentStyle } from "../../../config/appTheme";
import typeApprovalAPI from "../../../redux/actions/typeApprovalAPI";
import softwareIntersectionAPI from "../../../redux/actions/softwareIntersectionActions";
import CustomSelectV2 from "../../../components/customComponentsV2/common/select/CustomSelectV2";
import CustomAutoCompleteWithAPIV2 from "../../../components/customComponentsV2/common/searchBar/CustomAutoCompleteWithAPIV2";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CustomDialogBoxV2 from "../../../components/customComponentsV2/common/customDialogBox/CustomDialogBoxV2";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function SWMtoLegalLink({
  triggerOnSelectEE,
  selectedZoneMain,
  setSelectedZoneMain,
  setTotalSWMCount,
}) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const zoneFromurl = queryParams.get("zone");
  const eeFromurl = queryParams.get("ee_id");
  let swmFromUrl = queryParams.get("swm_id");

  useEffect(() => {
    console.log("---zoneFromurl---", zoneFromurl);
  }, [zoneFromurl]);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const selectedProjectDetails = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );

  const selectedSingleVariantDetails = useSelector(
    (state) => state.projectConfigReducer.selectedVariantDetails,
  );
  const [swmFromUrlState, setSwmFromUrlState] = useState(null);
  const [SWMComponentMainList, setSWMComponentMainList] = useState([]);
  const [swmCount, setSwmCount] = useState(0);
  const [projectID, setProjectID] = useState(null);
  const [variantID, setVariantID] = useState(null);
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(25);
  const [cardOpen, setCardOpen] = useState(true);

  const [linkedLegalRequirement, setLinkedLegalRequirement] = useState([]);
  const [selectedEEComponentMain, setSelectedEEComponentMain] = useState({});
  const [zoneMainOptionsList, setZoneMainOptionsList] = useState([]);

  const [selectedEEID, setSelectedEEID] = useState(null);
  const [selectedSWModule, setSelectedSWModule] = useState({});
  const [modifiedSWModuleList, setModifiedSWModuleList] = useState();
  const [selectedProjectZonesList, setSelectedProjectZonesList] = useState([]);
  const [selectedProjectIsZonal, setSelectedProjectIsZonal] = useState(false);
  const [swmGetTrigger, setSwmGetTrigger] = useState(false);
  const isMountedRef = useRef(false);
  const [actionDialogOpen, setActionDialogOpen] = useState(false);
  const [actionType1DialogOpen, setActionType1DialogOpen] = useState(false);
  const [pendingSWMActionDialogOpen, setPendingSWMActionDialogOpen] =
    useState(false);
  const [selectedPendingSWMAction, setSelectedPendingSWMAction] =
    useState(null);

  useEffect(() => {
    setSwmFromUrlState(swmFromUrl);
  }, [swmFromUrl]);

  useEffect(() => {
    setSelectedEEComponentMain(null);
    setSelectedEEID(null);
    setLinkedLegalRequirement([]);

    if (selectedProjectDetails?.project_id) {
      setProjectID(selectedProjectDetails?.project_id);
    } else {
      setProjectID(null);
    }
    if (selectedSingleVariantDetails?.variant_id) {
      setVariantID(selectedSingleVariantDetails?.variant_id);
    } else {
      setVariantID(null);
    }
  }, [selectedProjectDetails, selectedSingleVariantDetails]);

  const getLegalRequiremet = async (swm_id) => {
    let apiDetails = softwareIntersectionAPI.get_software_legal_requirements;

    if (!swm_id) {
      return;
    }

    let resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          ee_id: Number(selectedEEID),
          project_id: selectedProjectDetails?.project_id,
          variant_id: selectedSingleVariantDetails?.variant_id,
          // swm_id: selectedSWModule.id,
          swm_id: swm_id,
        },
      }),
    );
    if (resp?.error) {
      setLinkedLegalRequirement([]);
    } else {
      if (!resp?.data[0]?.linked_lr_details[0].lr_id) {
        setLinkedLegalRequirement([]);
        return;
      }
      let deStructuredLinkedLr = resp?.data[0]?.linked_lr_details.map(
        (data) => {
          const { ls_details, ...restData } = data;
          return {
            ...restData,
            ...ls_details,
          };
        },
      );
      setLinkedLegalRequirement(deStructuredLinkedLr);
    }
  };

  const handleSelectedComponent = (selectedObj) => {
    console.log();
    setSelectedSWModule(selectedObj);
    getLegalRequiremet(Number(selectedObj.id));
  };

  const unlinkLegalRequirement = async ({ lr_id, reason, callback }) => {
    let apiDetails = typeApprovalAPI.unlink_legal_from_swm;

    console.log("unlinkLegalRequirement", lr_id, reason);

    let resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          project_id: selectedProjectDetails?.project_id,
          variant_id: selectedSingleVariantDetails?.variant_id,
          ee_id: Number(selectedEEID),
          swm_id: Number(selectedSWModule.id),
          removing_lr_id: lr_id,
          reason: reason,
        },
        show_toast: true,
      }),
    );

    if (resp?.error) {
      console.log("Error in unlinking");
    } else {
      getLegalRequiremet(Number(selectedSWModule?.id));
      callback();
    }
  };

  useEffect(() => {
    const modifiedList = SWMComponentMainList.map((item) => {
      console.log("SWMComponentMainList", item);
      return {
        data: item,
        id: item.swm_id,
        cardDataArray: [
          {
            key: "Number",
            value: item.name,
            keyStyle: { fontWeight: 600 },
            valueStyle: { fontWeight: 600 },
          },
          {
            key: "Description",
            value: item.description,
          },
          {
            key: "Version",
            value: item.version,
          },
        ],
      };
    });
    setModifiedSWModuleList(modifiedList);
    if (modifiedList.length) {
      handleSelectedComponent(modifiedList[0]);
    } else {
      handleSelectedComponent({});
    }
  }, [SWMComponentMainList]);

  useEffect(() => {
    setSelectedProjectIsZonal(selectedProjectDetails?.is_zonal);
    setSelectedProjectZonesList(selectedProjectDetails?.project_zones);
  }, [selectedProjectDetails]);

  useEffect(() => {
    console.log(
      "---you changed selected pproject zone---",
      selectedProjectZonesList,
    );
    // If zonal, set the zone main options list & zone lined options list
    if (selectedProjectIsZonal) {
      /* Zone Main */
      let filteredZoneMainOptionsList = selectedProjectZonesList
        ?.map((el) => {
          return {
            value: el?.position,
            label: el?.zone_name,
          };
        })
        ?.sort((a, b) => a.label.localeCompare(b.label));
      setZoneMainOptionsList(filteredZoneMainOptionsList);

      /* Select zone from URL if available */
      const zoneFromUrlValue = filteredZoneMainOptionsList?.find(
        (zone) => zone.value === zoneFromurl,
      );
      console.log(
        "---filteredZoneMainOptionsList---",
        filteredZoneMainOptionsList,
        selectedProjectIsZonal,
        filteredZoneMainOptionsList?.[0]?.value,
      );

      if (zoneFromUrlValue) {
        setSelectedZoneMain(zoneFromUrlValue?.value);
      } else if (
        selectedProjectIsZonal &&
        filteredZoneMainOptionsList?.[0]?.value &&
        !selectedZoneMain
      ) {
        console.log(
          "---filteredZoneMainOptionsList in if---",
          filteredZoneMainOptionsList?.[0]?.value,
        );
        setSelectedZoneMain(filteredZoneMainOptionsList?.[0]?.value);
      } else if (selectedProjectIsZonal) {
        console.log(
          "---else if (selectedProjectIsZonal) ---",
          filteredZoneMainOptionsList?.[0]?.value,
        );
        setSelectedZoneMain(filteredZoneMainOptionsList?.[0]?.value);
      } else {
        console.log("---else---");
        setSelectedZoneMain(null);
      }
    }
  }, [selectedProjectZonesList]);

  const handleActionDialogOpen = () => {
    setActionDialogOpen(true);
  };

  const handleActionDialogClose = () => {
    setActionDialogOpen(false);
  };

  const handleActionType1DialogOpen = (swm) => {
    setActionType1DialogOpen(true);
  };

  const confirmUpdate = async () => {
    console.log("---selectedSWModule---", selectedSWModule);
    // Create the request object
    const reqObj = {
      current_time: new Date().toISOString(),
      project_id: Number(projectID),
      variant_id: Number(variantID),
      ee_id: Number(selectedEEID),
      swm_id: Number(selectedSWModule?.data?.swm_id),
      is_dependency_linking: false,
    };
    try {
      // Dispatch the update action type API
      const response = await dispatch(
        HandleApiActions({
          ...labCar.update_action_type,
          params: reqObj,
          show_toast: false,
        }),
      );
      setSwmGetTrigger(!swmGetTrigger);
      if (!response.error) {
        handleActionDialogClose();
      }
    } catch (error) {
      console.error("Failed to update action type", error);
    }
  };

  const updateChangesAndClose = () => {
    setSwmFromUrlState(null);
    handleActionDialogClose();
  };
  const handleActionType1DialogClose = () => {
    setActionType1DialogOpen(false);
  };

  const getSWMActionTypeTooltip = (actionType) => {
    switch (Number(actionType)) {
      case 1:
        return "Action Pending in Software Module to Software Module linking";
      case 2:
        return "Action Pending in Software Module to Legal linking";
      case 4:
        return "Action required in Software Module Attribute";
      case 5:
        return "Action pending in Software Module Version";
      default:
        return "";
    }
  };

  const handlePendingSWMActionDialogClose = () => {
    setPendingSWMActionDialogOpen(false);
    setSelectedPendingSWMAction(null);
  };

  const handleSWMActionTypeClick = (event, item) => {
    event.stopPropagation();

    if ([4, 5].includes(Number(item?.action_type))) {
      setSelectedPendingSWMAction(item);
      setPendingSWMActionDialogOpen(true);
      return;
    }

    if (Number(item?.action_type) === 2) {
      handleActionDialogOpen();
    } else if (Number(item?.action_type) === 1) {
      handleActionType1DialogOpen(item);
    }
  };

  const handleRedirectionToSWMAction = () => {
    const selectedSWM = selectedPendingSWMAction || selectedSWModule?.data;
    const selectedZoneDetails = selectedProjectZonesList?.find(
      (zone) => Number(zone?.position) === Number(selectedZoneMain),
    );
    const params = new URLSearchParams();
    const eeId = selectedSWM?.ee_id || selectedEEID;
    const swmId = selectedSWM?.swm_id || selectedSWModule?.id;

    if (eeId) {
      params.set("ee_id", eeId);
    }
    if (swmId) {
      params.set("swm_id", swmId);
    }
    params.set("actionMode", "swmAction");
    if (selectedZoneMain) {
      params.set(
        "selectedZone",
        selectedZoneDetails?.zone_name || selectedZoneMain,
      );
      params.set("zonePosition", selectedZoneMain);
    }
    if (page) {
      params.set("page", page);
    }

    navigate(`/dashboard/v2/EESWM?${params.toString()}`);
    handlePendingSWMActionDialogClose();
  };

  const eeParams = useMemo(() => {
    if (!projectID || !variantID) return {};
    return {
      project_id: Number(projectID),
      variant_id: Number(variantID),
      ...(selectedZoneMain && {
        zone_position: selectedZoneMain,
      }),
      ...(Number(eeFromurl) && { ee_id: Number(eeFromurl) }),
      status: true,
      page_number: 1,
      page_size: 10,
    };
  }, [projectID, variantID, selectedProjectIsZonal, selectedZoneMain]);

  const searchParams = useMemo(() => {
    if (!selectedEEID) {
      return null;
    }
    return {
      project_id: Number(projectID),
      variant_id: Number(variantID),
      ee_id: Number(selectedEEID),
      ...(Number(swmFromUrlState) && { swm_id: Number(swmFromUrlState) }),
      status: true,
      page_number: page,
      page_size: rowsPerPage,
    };
  }, [projectID, variantID, selectedEEID, page, rowsPerPage, swmFromUrlState]);

  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          // mr: 2,
          pr: 1.4,
        }}
      >
        <CustomButtonV2
          disabled={!projectID || !variantID}
          btnName="Create Ticket"
          handleOnClick={() => {
            navigate(`/dashboard/v2/type-approval/link/create?tab=${3}`);
          }}
        />
      </Box>
      <SlidingComponentLinkTemplate
        cardOpen={cardOpen}
        setCardOpen={setCardOpen}
        headerTitle={
          <Box>
            {/* First line: title */}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 0.5,
              }}
            >
              <Typography>Select Module</Typography>
              <Box
                onClick={() => {
                  setCardOpen(false);
                }}
                sx={{ cursor: "pointer" }}
              >
                <KeyboardArrowUpIcon />
              </Box>
            </Box>
            {/* Second line: zone + EE dropdown */}
            <Box
              display="flex"
              gap={1}
              sx={{
                width: "100%",
                mt: 0.5,
                gap: 1,
                alignItems: "center",
                mr: selectedProjectIsZonal ? 1 : 0,
              }}
            >
              {selectedProjectIsZonal && (
                <Box sx={{ flex: "0 0 40%" }}>
                  <CustomSelectV2
                    label={"Select Zone"}
                    optionsList={zoneMainOptionsList}
                    selectedValue={selectedZoneMain}
                    handleOnChange={(e) => setSelectedZoneMain(e.target.value)}
                    dark={true}
                    showLabel={false}
                    sx={{
                      height: 40,
                      border: "1px solid #ced4da",
                      borderRadius: 1,
                      background: "#fff",
                      ...componentStyle.searchField.textField,
                    }}
                  />
                </Box>
              )}
              <Box sx={{ flex: selectedProjectIsZonal ? "0 0 58%" : "1" }}>
                <CustomAutoCompleteWithAPIV2
                  key={`left-ee-${variantID}-${selectedZoneMain}`}
                  apiAction={labCar.get_ee_components_new}
                  searchKey={"description"}
                  placeholder={"Search EE Descriptions"}
                  firstItemDefaultSelect={true}
                  skipInitialSearch={false}
                  toolTipLength={30}
                  getSelectedItem={(selectedEE) => {
                    console.log("---selectedEE---", selectedEE);
                    setSelectedEEComponentMain(selectedEE);
                    setSelectedEEID(selectedEE?.ee_id);
                    if (!selectedEE?.ee_id) {
                      setSWMComponentMainList([]);
                      return;
                    }
                    if (!isMountedRef.current) {
                      isMountedRef.current = true;
                      return;
                    }
                  }}
                  displayKey="description"
                  valueObj={selectedEEComponentMain}
                  enableDarkMode={true}
                  txtFldStyle={componentStyle.searchField.textField}
                  sx={{
                    height: 40,
                    border: "1px solid #ced4da",
                    borderRadius: 1,
                    background: "#fff",
                    ...componentStyle.searchField.textField,
                  }}
                  skipApiCall={!projectID || !variantID}
                  params={eeParams}
                />
              </Box>
            </Box>
            {/* Third line: software search */}
            <Box sx={{ width: "100%", mt: 0.5 }}>
              <CustomSearchbarWithApiV2
                key={`left-swm-${selectedEEID}`}
                apiAction={labCar.get_sw_modules_new}
                searchKey={"name"}
                placeholder={"Search Number"}
                triggerApi={swmGetTrigger}
                getDataOnSearch={(data, resp) => {
                  if (resp.error) {
                    setSWMComponentMainList([]);
                  } else {
                    setSWMComponentMainList(resp.data);
                    setSwmCount(resp?.total_count);
                    setTotalSWMCount(resp?.total_count);
                  }
                }}
                skipApiCall={!searchParams}
                params={searchParams}
                iconColor={"white"}
                txtFldStyle={componentStyle.searchField.textField}
                sx={{
                  height: 40,
                  border: "1px solid #ced4da",
                  borderRadius: 1,
                  background: "#fff",
                  ...componentStyle.searchField.textField,
                }}
              />
            </Box>
          </Box>
        }
        linkedLegalRequirement={linkedLegalRequirement}
        unlinkLegalRequirement={unlinkLegalRequirement}
        handleSelectedComponent={(selectedObj) => {
          handleSelectedComponent(selectedObj);
        }}
        searchKeys={[
          "chapter",
          "name",
          "standard_number",
          "ls_id",
          "req_number",
        ]}
        dataList={modifiedSWModuleList}
        selectedComponentDetails={selectedSWModule}
        renderCardActionIcons={(item) => {
          return (
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
              }}
            >
              {[1, 2, 4, 5].includes(Number(item.action_type)) && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                  }}
                >
                  <Tooltip title={getSWMActionTypeTooltip(item.action_type)}>
                    <IconButton
                      size="small"
                      sx={{ color: "black" }}
                      onClick={(event) => handleSWMActionTypeClick(event, item)}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
            </Box>
          );
        }}
        page={page}
        rowsPerPage={rowsPerPage}
        handlePageChange={(selectedPage) => {
          setPage(selectedPage);
        }}
        totalCount={swmCount}
      />
      <CustomDialogBoxV2
        open={actionDialogOpen}
        onClose={handleActionDialogClose}
        title="Action Required"
        successButtonName="Yes"
        rejectButtonName="No"
        actionButtonStyle="continuous"
        onClickSuccess={confirmUpdate}
        onClickReject={updateChangesAndClose}
      >
        <Box sx={{ width: "300px" }}>
          <Typography sx={{ ...componentStyle.font.text }}>
            Are you sure the intersection for Software module is completed?
          </Typography>
        </Box>
      </CustomDialogBoxV2>

      <CustomDialogBoxV2
        open={actionType1DialogOpen}
        onClose={handleActionType1DialogClose}
        title="Action Pending"
        successButtonName="Link Now"
        rejectButtonName="Link Later"
        actionButtonStyle="continuous"
        onClickSuccess={() => {
          console.log(
            "---handleActionType1DialogClose---",
            selectedEEComponentMain,
            selectedSWModule,
          );
          navigate(
            `/dashboard/v2/link?project_id=${projectID}&variant_id=${Number(
              variantID,
            )}&ee_id=${selectedEEComponentMain?.ee_id}&swm_id=${selectedSWModule.id
            }&selectedZone=${selectedZoneMain}&tab=1`,
          );
          handleActionType1DialogClose();
        }}
        onClickReject={handleActionType1DialogClose}
      >
        <Box sx={{ width: "300px" }}>
          <Typography sx={{ ...componentStyle.font.text }}>
            Software module dependency linking is pending!
          </Typography>
        </Box>
      </CustomDialogBoxV2>

      <CustomDialogBoxV2
        open={pendingSWMActionDialogOpen}
        onClose={handlePendingSWMActionDialogClose}
        title="Action"
        successButtonName="Link Now"
        rejectButtonName="Link Later"
        actionButtonStyle="continuous"
        onClickSuccess={handleRedirectionToSWMAction}
        onClickReject={handlePendingSWMActionDialogClose}
      >
        <Box sx={{ width: "300px" }}>
          <Typography sx={{ ...componentStyle.font.text }}>
            {Number(selectedPendingSWMAction?.action_type) === 4
              ? "Action pending in Software Module Attribute"
              : "Action pending in Software Module Version"}
          </Typography>
        </Box>
      </CustomDialogBoxV2>

      <CustomDialogBoxV2></CustomDialogBoxV2>
    </Box>
  );
}

export default SWMtoLegalLink;
